<template>
    <div id="quadro">
        <div class="header">
            <div style="display: flex; flex-direction: column; align-items: start; width: 70%;">
                <v-btn @click="$emit('close-item')" variant="text" color="inherit"><img
                        src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
                        alt=""></v-btn>
                <p class="submenu-title">Quadro de avisos</p>
            </div>


        </div>

        <div style="overflow: auto; height: 65%;">
            <v-expansion-panels style="margin-top: 5%;" variant="accordion" v-if="loaded">
                <v-expansion-panel v-for="(notification, i) in notifications" :key="notification.id" @click="defineViewed(notification, i)">
                    <v-expansion-panel-title>
                        <div class="icon-wrapper">
                            <img src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/00c25f1c-511f-435c-8b49-71a8a4a37a0f.svg"
                                alt="">
                        </div>
                        <div style="width: 60%;">
                            <p style="color: #464646;">{{ notification.text }}</p>
                            <span style="font-size: 11px;color: #464646;"></span>
                        </div>
                        <div style="margin-left: 3%;">
                            <img v-if="!notification.read" style="margin-right: 10px;"
                            src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/3f0db893-ff35-49d3-aad8-d28b39d5e1cb.svg"
                            alt="">
                        </div>
                        <template v-slot:actions="{ expanded }">
                            <img :style="!expanded ? 'transform: rotateX(180deg) !important' : ''"
                                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/2ac66bd2-2a98-4cff-a601-296fb45f33ed.svg"
                                alt="">
                        </template>
                    </v-expansion-panel-title>

                    <v-expansion-panel-text
                        style="font-size: 12px; text-align: start;color: #464646; background-color: #f5f5f5;">
                        {{ notification.text }}

                    </v-expansion-panel-text>

                </v-expansion-panel>
            </v-expansion-panels>
            <v-progress-circular
                v-else
                indeterminate
                color="#BC4AFF"
                :size="70"
                :width="7"
                style="margin-top: 10%;"
            ></v-progress-circular>
        </div>
    </div>
</template>

<script setup>
import { defineEmits, onMounted, ref } from 'vue';
import requestApi from '@/utils/requestApi';
import { useGlobalStateStore } from '../../../../store';

const globalStateStore = useGlobalStateStore();

defineEmits(["close-item"])

const notifications = ref({})
const loaded = ref(false)

async function getNotifications() {
    return requestApi({
        url: `/v2/notices/video/${process.env.VUE_APP_VIDEO_ID}/user/${window.ovmConfig.env['CPF']}`,
        headers: {
            BCS: globalStateStore.uuid
        },
        method: "get",
    }).then(response => {
        notifications.value = response.data['notices']
        loaded.value = true
        console.log(notifications)
    })
}

async function defineViewed(notification, i) {
    if (notification.read !== true) {
        return requestApi({
        url: `/v2/notices/notice/${notification.id}/reading_notice`,
        headers: {
            BCS: globalStateStore.uuid
        },
        method: "get",
        }).then(() => {
            notifications.value[i].read = true
        })
    }
}

onMounted(async () => {
    await getNotifications()
})
</script>

<style scoped>
#quadro {
    width: 100%;
    height: 100%;
    background: #fff;
    position: absolute;
    top: 0;
    z-index: 1;
}

.header {
    height: 25%;
    background-color: #BC4AFF;
    display: flex;
}

.submenu-title {
    color: white;
    margin-top: 15%;
    font-size: 20px;
    text-align: start;
    margin-left: 10%;
}

.icon-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F6E7FF;
    border-radius: 50%;
    margin-right: 20px;
}
</style>